var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ArraySchema, Schema, type } from "@colyseus/schema";
/**
 * The three piles a Fortress deck is split into. Card ids only; the catalogue
 * (pattern/cost/etc.) is looked up by id.
 */
export class CardPile extends Schema {
    constructor() {
        super(...arguments);
        /** Face-down draw pile (not yet revealed). */
        this.hidden = new ArraySchema();
        /** Face-up market row players may implement / cycle. */
        this.faceUp = new ArraySchema();
        /** Spent / cycled-out cards. */
        this.discarded = new ArraySchema();
        /** Card ids in `faceUp` that are locked: can't be cycled, still purchasable.
         * Every lock (Supreme Bondage's) lifts immediately after the next
         * round-start cycle step. */
        this.locked = new ArraySchema();
    }
}
__decorate([
    type(["string"])
], CardPile.prototype, "hidden", void 0);
__decorate([
    type(["string"])
], CardPile.prototype, "faceUp", void 0);
__decorate([
    type(["string"])
], CardPile.prototype, "discarded", void 0);
__decorate([
    type(["string"])
], CardPile.prototype, "locked", void 0);
//# sourceMappingURL=CardPile.js.map